//imports
import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import { Chip } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import { Toolbar, Typography } from "@mui/material";
import Alert from "@mui/material/Alert";
import { Slide } from "@mui/material";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { SETTINGS_API_05 } from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";
import { STS, CHAINCODE, MENUTYPECODE } from "../../api/ApiModel";
import { useSelector } from "react-redux";
const Tables = () => {
  //hooks
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState(null);
  const [datatable, setDatatable] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const isEdit = location.state?.actionText === "Edit";
  const [errors, setErrors] = useState({});
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [compcode, setcompcode] = useState("");
  const [loccode, setloccode] = useState("");
  const [restcode, setrestcode] = useState("");
  const [formData, setFormData] = useState({
    TABLENAME: "",
    NOOFSEATS: "",
    TABLECODE: "",
    QRCODE:
      "http://216.219.84.38:6565/Guest?compcode=${COMPCODE}=&loccode=${LOCCODE}=&restcode=${RESTCODE}==&tablecode=",
    COLORCODE: "#000000",
  });

  useEffect(() => {
    fetchData();
  }, [COMPCODE, LOCCODE, RESTCODE]);

  useEffect(() => {
    if (selectedItem) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        TABLENAME: selectedItem.TABLENAME,
        NOOFSEATS: String(selectedItem.NOOFSEATS),
        COLORCODE: selectedItem.COLORCODE,
        TABLECODE: String(selectedItem.TABLECODE),
      }));
    }
  }, [selectedItem]);
  useEffect(() => {
    // Update the QRCODE URL dynamically whenever TABLECODE, COMPCODE, or LOCCODE changes
    setFormData((prevFormData) => ({
      ...prevFormData,
      QRCODE: `http://216.219.84.38:6565/Guest?compcode=${encodeURIComponent(
        btoa(COMPCODE)
      )}&loccode=${encodeURIComponent(
        btoa(LOCCODE)
      )}&restcode=${encodeURIComponent(
        btoa(RESTCODE)
      )}&tablecode=${encodeURIComponent(btoa(prevFormData.TABLECODE))}`,
    }));
  }, [formData.TABLECODE, COMPCODE, LOCCODE]); // Dependencies for TABLECODE, COMPCODE, and LOCCODE

  //functions
  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_05, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        STS: CON_STATUS_ACTIVE,
      });
      setDatatable(result);
    } catch (err) {
      setError(err);
    }
  };
  //handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  //postapi
  const handleConfirmClick = async () => {
    const { TABLENAME, NOOFSEATS, COLORCODE } = formData;
    const requiredFields = [
      { name: "TABLENAME", value: TABLENAME, label: "Table Name" },
      { name: "NOOFSEATS", value: NOOFSEATS, label: "No Of Seats" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }

    // const isDuplicate = datatable.some(item => item.TABLENAME === TABLENAME && item.TABLECODE !== formData.TABLECODE);

    if (datatable) {
      const isDuplicate = datatable.some((item) => {
        if (
          item.TABLECODE != formData.TABLECODE &&
          item.TABLENAME === TABLENAME
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setSnackbarMessage("Table name already exists."); // Show snackbar if duplicate found
        setOpenErrorSnackbar(true);
        return;
      }
    }
    const staticValues = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      STS: CON_STATUS_ACTIVE,
      QRCODE: "aGVsbG8gd29ybGQ=",
      LOCDATE: new Date().toISOString(),
    };

    const payload = {
      ...formData,
      ...staticValues,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_05, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setFormData({
        TABLENAME: "",
        NOOFSEATS: "",
        COLORCODE: "#000000",
      });
    } catch (error) {
      console.error("Error:", error);
    }
    setTimeout(() => {
      navigate("/vtables");
    }, 2000);
  };

  const handleClearClick = () => {
    setFormData({
      TABLENAME: "",
      NOOFSEATS: "",
      COLORCODE: "#000000",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  const gotToPage = () => {
    navigate("/vtables");
  };
  //validations
  const handlenumInputValidation = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value)) {
      setError(""); // Clear any existing error message
      handleInputChange(event); // Update state with the valid input
    } else {
      setError("Only numbers and floats are allowed."); // Set error message
    }
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover">Home</Link>
                <Link underline="hover">Settings</Link>
                <Link underline="hover">Tables</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar label={{ name: isEdit ? "Edit Table" : "Create Table" }} />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid spacing={2} item xs={12} md={6}>
            <Grid item lg={12} md={12} xs={12} sm={12}>
              <TextField
                label={
                  <span>
                    Table Name / Number<span style={{ color: "red" }}> *</span>
                  </span>
                }
                name="TABLENAME"
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                value={formData.TABLENAME}
                onChange={handleInputChange}
                error={Boolean(errors.TABLENAME)}
                helperText={errors.TABLENAME}
              />
            </Grid>

            <Grid item lg={12} md={12} xs={12} sm={12} mt={2}>
              <TextField
                label={
                  <span>
                    No Of Seats<span style={{ color: "red" }}> *</span>
                  </span>
                }
                name="NOOFSEATS"
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                value={formData.NOOFSEATS}
                onChange={handlenumInputValidation} // Ensure function is correctly used
                error={Boolean(errors.NOOFSEATS)}
                helperText={errors.NOOFSEATS}
              />
            </Grid>

            <Grid item lg={12} md={12} xs={12} sm={12} mt={2}>
              <TextField
                label="Table Color Code"
                name="COLORCODE"
                type="color"
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <Chip
                      label={formData.COLORCODE}
                      type="color"
                      style={{
                        backgroundColor: formData.COLORCODE,
                        color: "white",
                        marginLeft: "10px",
                      }}
                    />
                  ),
                }}
                value={formData.COLORCODE}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} item xs={12} md={6}>
            <Grid item lg={12} md={12} xs={12} sm={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  background: theme.palette.background.default,
                  p: 2,
                  borderRadius: "4px",
                  boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,
                }}
              >
                <Toolbar
                  sx={{
                    width: "100%",
                    background: theme.palette.background.paper,
                    borderTopLeftRadius: 4,
                    borderTopRightRadius: 4,
                  }}
                >
                  <Typography
                    sx={{
                      color:
                        theme.palette.mode === "dark" ? "#FFFFFF" : "#181818", // styleName: Heading 5;

                      fontSize: "20px",
                      fontWeight: 600,
                    }}
                  >
                    QR Code
                  </Typography>
                </Toolbar>
                <QRCodeSVG
                  value={formData.QRCODE || "DefaultQRCode"}
                  size={148}
                  marginSize={2}
                  mt={2}
                />
                {/* <TextField
                label="Table QR Code"
                size="small"
                fullWidth
                variant="outlined"
                value={formData.QRCODE}
                onChange={handleInputChange}
                helperText="Generated QR Code based on Table Code"
                InputProps={{ readOnly: true }}
              /> */}
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          TransitionComponent={(props) => <Slide {...props} direction="left" />} // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? "Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={3000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default Tables;
